import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Payment_Mode_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Payment_Mode_Report() {
  // 1. States
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transactionMode, setTransactionMode] = useState("bank_transfer");

  // 2. Fetch Logic
  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    setPaymentData([]);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        user_id: localStorage.getItem("user_id") || 14857,
        transaction_mode: transactionMode,
      };

      const response = await simplePostCall(
        ApiConfig.paymentmodereportports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setPaymentData(response.data || []);
      } else {
        setPaymentData([]);
      }
    } catch (error) {
      console.error("Error fetching payment mode report:", error);
      setPaymentData([]);
    } finally {
      setLoading(false);
    }
  }, [transactionMode]);

  // 3. Initial Load & Dependencies
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchInitialData();
  };

  return (
    <div className="payment-mode-container" style={{ paddingTop: "25px" }}>
      <div className="payment-mode-header">
        <h3>Payment Mode Report</h3>
        <div className="export-btn-container-payment">
          <button className="export-btn-payment">
            Export <span className="arrow-down-payment"></span>
          </button>
        </div>
      </div>

      {/* Filter Section */}
      <div className="payment-mode-body">
        <div className="filter-section-payment">
          <select
            className="parent-select-payment"
            value={transactionMode}
            onChange={(e) => setTransactionMode(e.target.value)}
          >
                  <option value="">Select Mode</option>
                  <option value="cash">Cash</option>
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="cheque">Cheque</option>
                  <option value="dd">DD</option>
          </select>
          <button
            className="search-btn-payment"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>
          

        {/* Table Section */}
        <div className="table-container-payment">
          <table className="payment-mode-table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Paid By User</th>
                <th>Student Name</th>
                <th>Grade/Div</th>
                <th>Transaction Id</th>
                <th>Amount</th>
                <th>Mode</th>
              </tr>
            </thead>
            <tbody>
              {paymentData.length > 0 ? (
                paymentData.map((item, index) => (
                  <tr key={item.transaction_id || index}>
                    <td>{index + 1}</td>
                    <td>{item.paid_by_user}</td>
                    <td>{item.student_name}</td>
                    <td>
                      {item.grade} ({item.division})
                    </td>
                    <td>
                      <strong>{item.transaction_id}</strong>
                    </td>
                    <td>{formatNumber(item.transaction_amount)}</td>
                    <td>
                      <span className="mode-label">
                        {item.transaction_mode.replace("_", " ")}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-results-payment text-center">
                    {loading ? (
                      <div className="d-flex justify-content-center">
                        <ScaleLoader color="#F4BB44" height={25} />
                      </div>
                    ) : (
                      "No results found for this payment mode."
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Payment_Mode_Report;
